import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_new_wrkrs_provd_w_a_copy_of_the_facs_workplace_rules_av'

export const dataPointDefinition = {
  retracedId: 'are_all_new_wrkrs_provd_w_a_copy_of_the_facs_workplace_rules_av',
  name: "Are all new workers provided with a copy of the facility's workplace rules, available in all languages spoken at the facility, during orientation?",
  description:
    'The intent of this question is to understand if workers new to the facility are provided with a copy of the workplace rules during orientation. \r\r\n\r\r\n"Workplace rules" (also known as "workplace code of conduct" or "worker code of conduct" lays out the facility\'s expectations for appropriate workplace behavior.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5920,
  sectionId: '2.2.4.3',
  impactArea: 'General Work Environment',
  impactAreaId: 'GENERAL_WORK_ENVIRONMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
